export const EV_EXISTING_PATHS = {
  TRANSFER: "/smart-charging/ev/existing/transfer/",
  COMPATIBILITY: "/smart-charging/ev/existing/compatibility",
  TERMS: "/smart-charging/ev/existing/terms",
};

export const EV_EXISTING_ROUTES = [
  EV_EXISTING_PATHS.TRANSFER,
  EV_EXISTING_PATHS.COMPATIBILITY,
  EV_EXISTING_PATHS.TERMS,
];
